


















  import { Component, mixins } from 'nuxt-property-decorator'
  import LazyHydrate from 'vue-lazy-hydration'
  import { namespace } from 'vuex-class'
  import { AsyncComponent } from 'vue'

  import { CMS } from '@one/types'
  import pages from '../breadcrumbs'
  import SeoMethodsMixin, { DIVIDER } from '~/mixins/SeoMethodsMixin'

  const cms = namespace('cms')
  const layout = namespace('layout')

  @Component({
    middleware: ['isAuthenticatedOrPlatformOpened'],
    meta: {
      breadcrumb: {
        name: pages.BLOG,
        link: '/blog',
      },
    },
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
      LazyHydrate,
    },
  })
  export default class Index extends mixins<SeoMethodsMixin>(SeoMethodsMixin) {
    @cms.Getter articleBySlug: any
    @layout.State breadcrumbs: any
    @layout.Mutation('SET_BREADCRUMBS') setBreadcrumbs: any
    mainComponentClass = 'one-article-page'

    availableComponents: Record<string, AsyncComponent> = {
      html: () => import('~/components/organisms/grid/shared/OneCmsDynamicComponent.vue'),
      staticHtml: () => import('~/components/organisms/grid/shared/OneCmsStaticComponent.vue'),
      image: () => import('~/components/molecules/images/OneCmsGridImageComponent.vue'),
      link: () => import('~/components/molecules/links/OneCmsGridLinkComponent.vue'),
      productContainer: () =>
        import('~/components/organisms/grid/content/OneCmsProductContainer.vue'),
      productsListing: () => import('~/components/organisms/grid/static/OneProductsListing.vue'),
      Category: () => import('~/components/organisms/grid/content/OneCmsCategoryOverview.vue'),
      TopProducts: () => import('~/components/organisms/grid/content/OneCmsTopProducts.vue'),
      StaticBanners: () => import('~/components/organisms/grid/content/OneCmsStaticBanners.vue'),
      carouselWithCategories: () =>
        import('~/components/organisms/grid/content/OneCmsCategoriesListWithBanner.vue'),
      customizableProductsRotator: () =>
        import('~/components/organisms/grid/content/OneCmsProductsRotator.vue'),
      carouselWithThumbnails: () =>
        import('~/components/organisms/grid/content/OneCmsCarouselWithThumbnails.vue'),
      youtube: () => import('~/components/organisms/grid/shared/OneCmsYoutubeComponent.vue'),
      textEditor: () => import('~/components/organisms/grid/shared/OneCmsTextEditorComponent.vue'),
      codesScanner: () => import('~/components/organisms/shared/OneBarcodeScanner.vue'),
      gridArticle: () => import('~/components/organisms/grid/content/OneCmsArticle.vue'),
      productPack: () => import('~/components/organisms/grid/content/OneCmsProductPack.vue'),
    }

    mounted() {
      this.$plugins.onMounted(this.mainComponentClass, this)
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    head() {
      if (!this.$tenantConfig.tenantKey) {
        return {}
      }
      return {
        title: this.structuredSeoTitle(DIVIDER.DOT, [this.article.seo.title]),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.structuredSeoTitle(DIVIDER.DASH, [this.article.seo.description]),
          },
        ],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'Article',
              about: {
                '@type': 'Event',
                name: 'Article',
              },
            },
          },
        ],
      }
    }

    created() {
      this.setBreadcrumbs([...this.breadcrumbs, { name: this.article.seo.title }].slice(0, 2))
    }

    get article(): CMS.Responses.ArticleBody {
      return this.articleBySlug(this.$route.params.article)
    }

    get bodyCss() {
      return this.article.bodyCss
    }

    get bannerUrl() {
      return this.article.bannerUrl
    }

    get bodyHtml() {
      return this.article.bodyHtml
    }

    get bodyJavascript() {
      return this.article.bodyJavascript
    }

    async fetch({ store, params, error }: any) {
      try {
        await store.dispatch('cms/fetchArticle', params.article)
        return Promise.resolve()
      } catch (err) {
        return error({
          statusCode: err.response && err.response.status,
          message: err.response && err.response.data,
          err: err,
        })
      }
    }
  }
